/*global chrome*/
import { appEnvironment } from 'helpers/constants';
import { debounce } from 'lodash';
import { isArrayEqual } from 'helpers/array';
import { ChromeBridge } from 'services/chrome/chromeBridge';
import { purgeAndReload } from 'services/featureFlags';

export function initChromeTools() {
  if (appEnvironment === 'chrome') {
    const openTabs = new OpenTabs();
    openTabs.initialize();
  }
}

class OpenTabs {
  constructor() {
    this.tabs = [];
  }
  initialize() {
    this.startListening();
    this.changeDetected();
  }

  changeDetected = () => {
    chrome.tabs.query({}, (tabs) => {
      const URL_MATCH = /^https?:\/\//i;
      tabs = tabs.filter((tab) => !tab.incognito && URL_MATCH.test(tab.url));
      if (!isArrayEqual(this.tabs, tabs)) {
        this.tabs = tabs;
        ChromeBridge.setOpenTabs(tabs);
      }
    });
  };

  messageFromAnotherExtension = (request, sender, sendResponse) => {
    if (request.action === 'purge_and_reload') {
      purgeAndReload();
    }
  };

  startListening() {
    const tabActivityListener = debounce(this.changeDetected, 10, { maxWait: 500 });
    const messageFromAnotherExtensionListener = this.messageFromAnotherExtension;
    chrome.tabs.onAttached.addListener(tabActivityListener);
    chrome.tabs.onCreated.addListener(tabActivityListener);
    chrome.tabs.onDetached.addListener(tabActivityListener);
    chrome.tabs.onMoved.addListener(tabActivityListener);
    chrome.tabs.onUpdated.addListener(tabActivityListener);
    chrome.tabs.onRemoved.addListener(tabActivityListener);
    chrome.runtime.onMessage.addListener(messageFromAnotherExtensionListener);
  }
}
